import _ from 'underscore';
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useWindowSize } from '@bingads-webui-campaign-react/common-hooks';

import { ChatDialog } from './chat-dialog';
import { ChatLabel } from './chat-label';

export function ChatEntrance(props) {
  const {
    onStartLiveChat,
    onRejectLiveChat,
    minChatWidth,
    minChatHeight,
    i18n,
    ref,
  } = props;

  const [isShowLabel, setIsShowLabel] = useState(false);
  const { width, height } = useWindowSize();
  const isSmallScreen = width < minChatWidth || height < minChatHeight;

  const onStartChat = useCallback(() => {
    setIsShowLabel(true);
    if (_.isFunction(onStartLiveChat)) {
      onStartLiveChat();
    }
  }, [onStartLiveChat]);

  const onRejectChat = useCallback(() => {
    setIsShowLabel(true);
    if (_.isFunction(onRejectLiveChat)) {
      onRejectLiveChat();
    }
  }, [onRejectLiveChat]);

  return (
    <React.Fragment>
      {
        !isShowLabel && !isSmallScreen && <ChatDialog
          onStartChat={onStartChat}
          onRejectChat={onRejectChat}
          ref={ref}
          i18n={i18n}
        />
      }

      {
        (isShowLabel || isSmallScreen) &&
        <ChatLabel
          onStartChat={onStartChat}
          i18n={i18n}
        />
      }

    </React.Fragment>

  );
}

ChatEntrance.propTypes = {
  onStartLiveChat: PropTypes.func.isRequired,
  onRejectLiveChat: PropTypes.func,
  minChatWidth: PropTypes.number,
  minChatHeight: PropTypes.number,
  ref: PropTypes.shape({}),
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }),
};

ChatEntrance.defaultProps = {
  onRejectLiveChat: _.noop,
  minChatWidth: 768,
  minChatHeight: 680,
  ref: undefined,
  i18n: { getString: value => value },
};
